import React, { useState } from 'react';
import { Button } from '@mui/material'; // Make sure to import Button from MUI
import { useNavigate } from 'react-router-dom';

const NewDealAdmin = ({ children, ...rest }) => {
  const [userRole] = useState(localStorage.getItem('userRole')); // userRole is a string
  const navigate = useNavigate(); // useNavigate hook for routing
  // console.log(userRole); // Check if the value is coming correctly from localStorage

  return (
    <>
      {userRole === 'admin' && (
        <div style={{ backgroundColor: '#c6b79b', padding: '10px 0px' }}>
        <Button
          variant="contained"
          color="success"
          style={{ marginBottom: '10px' }}
          onClick={() => navigate('/discover/new')}
        >
          Create New Deal
        </Button>
        </div>
      )}
    </>
  );
};

export default NewDealAdmin;
